import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { StateCultureListService } from '../../service/stateculture-list/stateculture-list.service';
import { StateListService } from '../../../state/service/state-list/state-list.service';

@Component({
	selector: 'app-stateculture-list',
	templateUrl: './stateculture-list.component.html',
	providers: [
		StateCultureListService,
		StateListService,
		HttpModule
	]
})
export class StateCultureListComponent implements OnInit {

	private token;
	public cultures: any[] = [];
	public states: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Cultura/Descricao";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	stateCulture: FormGroup;

	constructor(fb: FormBuilder, private stateCultureListService: StateCultureListService, private stateListService: StateListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.stateCulture = fb.group({
			'Cultura': '',
			'Estado': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.getStates();
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchStateCulture(this.stateCulture.value, 0, false);
	}

	getStates() {
		this.stateListService.getActiveStates(this.token).subscribe(result => {
			console.log(result);
			this.states = result.Result;
		}, error => {
			console.log(error);
		});
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchStateCulture(this.stateCulture.value, this.currentPage, false);
	}


	searchStateCulture(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Cultura/Descricao";
			this.sort = "asc";
			this.currentPage = 0;
		}
		console.log(value);
		this.stateCultureListService.searchStateCulture(this.token, value.Cultura, value.Estado, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.cultures = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchStateCulture(this.stateCulture.value, $event, false);
	}
}



// WEBPACK FOOTER //
// ./src/app/stateculture/component/stateculture-list/stateculture-list.component.ts